"use strict";

exports.__esModule = true;
exports.ResetPasswordScreen = ResetPasswordScreen;
exports.resetPassword = resetPassword;
exports.validateSession = validateSession;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _queryString = _interopRequireDefault(require("query-string"));
var _reactFinalForm = require("react-final-form");
var _reactIntl = require("react-intl");
var _reactRouterDom = require("react-router-dom");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _RestAPI = require("../../API/RestAPI");
var _AuthContext = require("../../Auth/AuthContext");
var _Core = require("../../Core");
var _PasswordEditor = require("../../Form/PasswordEditor");
var _Notifications = require("../../Notifications");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var EditorBody = _styledComponents["default"].div.withConfig({
  displayName: "ResetPasswordScreen__EditorBody",
  componentId: "sc-2v9kkk-0"
})(["display:flex;overflow:auto;flex-direction:column;flex:1;padding:1rem;margin:auto;background:", ";color:", ";height:100vh;.", "{color:", " !important;}.", "{background:#ffffff !important;color:", " !important;}"], function (props) {
  return props.theme.LandingScreenColor;
}, function (props) {
  return props.theme.LandingScreenTextColor;
}, _core.Classes.LABEL, function (props) {
  return props.theme.LandingScreenTextColor;
}, _core.Classes.INPUT, function (props) {
  return props.theme.LandingScreenTextColor;
});
var ErrorWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ResetPasswordScreen__ErrorWrapper",
  componentId: "sc-2v9kkk-1"
})(["h4,p,&:nth-child(1){color:#ffffff !important;margin:auto;}"]);
function ResetPasswordScreen(props) {
  var location = (0, _reactRouterDom.useLocation)();
  var parsed = _queryString["default"].parse(location.search);
  var userId = parsed.userId;
  var sessionId = parsed.sessionId;
  var api = _react["default"].useContext(_RestAPI.RestAPIContext);
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var theme = _react["default"].useContext(_styledComponents.ThemeContext);
  var auth = _react["default"].useContext(_AuthContext.AuthContext);
  var _useState = (0, _react.useState)("INITIAL"),
    passwordResetStatus = _useState[0],
    setPasswordResetStatus = _useState[1];
  var handleSubmit = function handleSubmit(values) {
    resetPassword(api, {
      id: userId,
      password: values.password
    }).then(function (response) {
      if (response) {
        setPasswordResetStatus("SUCCESS");
        setTimeout(function () {
          window.location.replace("/");
          return auth.logout();
        }, 2000);
      }
    })["catch"](function () {
      setPasswordResetStatus("ERROR");
    });
  };
  (0, _react.useEffect)(function () {
    if (passwordResetStatus === "ERROR") {
      _Notifications.Notification.then(function (toaster) {
        return toaster.show({
          icon: "warning-sign",
          intent: _core.Intent.DANGER,
          message: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "ResetPassword.failed",
            defaultMessage: "Failed to change password"
          })
        });
      });
    }
    if (passwordResetStatus === "SUCCESS") {
      _Notifications.Notification.then(function (toaster) {
        return toaster.show({
          icon: _icons.IconNames.TICK,
          intent: _core.Intent.SUCCESS,
          message: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "ResetPassword.success",
            defaultMessage: "Successfully changed password. Redirecting to login page"
          })
        });
      });
    }
  }, [passwordResetStatus]);
  return /*#__PURE__*/_react["default"].createElement(EditorBody, null, /*#__PURE__*/_react["default"].createElement(_Core.AsyncLoader, {
    load: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            return _context.a(2, validateSession(api, sessionId));
        }
      }, _callee);
    }))
  }, function (_ref2) {
    var loaded = _ref2.loaded,
      fetching = _ref2.fetching,
      error = _ref2.error,
      data = _ref2.data;
    {
      fetching && !data && !loaded && /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
    }
    if (error) {
      return /*#__PURE__*/_react["default"].createElement(ErrorWrapper, null, /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
        error: error,
        title: "Unauthorised"
      }));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        maxWidth: "500px",
        margin: "auto",
        border: "#000000",
        background: "#ffffff",
        borderRadius: "7px"
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, {
      onSubmit: handleSubmit
    }, function (_ref3) {
      var handleSubmit = _ref3.handleSubmit,
        pristine = _ref3.pristine,
        invalid = _ref3.invalid;
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit,
        style: {
          minWidth: "400px",
          padding: "14px",
          margin: "auto"
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginBottom: "5px"
        }
      }, /*#__PURE__*/_react["default"].createElement(_core.Label, {
        style: {
          margin: "3px",
          marginBottom: "10px",
          width: "100%",
          backgroundColor: "#ffffff",
          padding: "10px",
          fontSize: theme.fontSizeMedium,
          textAlignLast: "center"
        }
      }, "Change Password")), /*#__PURE__*/_react["default"].createElement(_PasswordEditor.PasswordEditor, {
        id: "password"
      }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
        style: {
          width: "100%",
          padding: "3px"
        },
        type: "submit",
        icon: _icons.IconNames.FLOPPY_DISK,
        intent: _core.Intent.PRIMARY,
        text: translate("ResetPassword.submitButton.text", "Submit"),
        disabled: pristine || invalid || passwordResetStatus === "SUCCESS"
      }));
    }));
  }));
}
function resetPassword(_x, _x2) {
  return _resetPassword.apply(this, arguments);
}
function _resetPassword() {
  _resetPassword = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(api, data) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          return _context2.a(2, api.put("/api/v1/auth/profile/current/password-reset", data));
      }
    }, _callee2);
  }));
  return _resetPassword.apply(this, arguments);
}
function validateSession(_x3, _x4) {
  return _validateSession.apply(this, arguments);
}
function _validateSession() {
  _validateSession = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(api, sessionId) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          return _context3.a(2, api.get("/api/v1/auth/reset-password/validate?sessionId=" + sessionId));
      }
    }, _callee3);
  }));
  return _validateSession.apply(this, arguments);
}